import { quotationList } from "constants/quotation";

const initialState = {
  quotationList: {},
};

const quotation = (state = initialState, action) => {
  switch (action.type) {
    case quotationList:
      return { ...state, quotationList: action.payload };
    default:
      return state;
  }
};

export default quotation;
